import { render, staticRenderFns } from "./for-pc.vue?vue&type=template&id=7b6734c4"
import script from "./for-pc.vue?vue&type=script&lang=js"
export * from "./for-pc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports